import styled from 'styled-components';

import { DataTable } from 'components/DataTable';

import { BUNDLE_TABLE_COLUMNS, type BundleRow } from './constants/bundlesColumns';

type BundlesDataTableViewProps = {
    bundles: BundleRow[];
    selectedBundleIds: string[];
    setSelectedBundleIds: React.Dispatch<React.SetStateAction<string[]>>;
    /** La pagination appartient à la page, partagée avec le kanban : la table la consomme au défilement. */
    hasMore: boolean;
    onLoadMore: () => Promise<unknown>;
};

export const BundlesDataTableView = ({
    bundles,
    selectedBundleIds,
    setSelectedBundleIds,
    hasMore,
    onLoadMore,
}: BundlesDataTableViewProps) => {
    return (
        <TableContainer>
            {/* Pas de virtualisation ici : les cellules « Caisses » et « Stats » font plusieurs lignes,
                et le virtualiseur de la `DataTable` travaille à hauteur de ligne fixe. */}
            <DataTable<BundleRow>
                columns={BUNDLE_TABLE_COLUMNS}
                data={bundles}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/bundle/${row._id}`}
                defaultSortBy="scheduledPreparationDate"
                defaultSortOrder="asc"
                emptyMessage="Aucun bundle."
                enableSelection
                selectedKeys={selectedBundleIds}
                onSelectionChange={setSelectedBundleIds}
                hasMore={hasMore}
                fetchMore={onLoadMore}
            />
        </TableContainer>
    );
};

const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    overflow: hidden;
`;
